/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Tracking_Exception_CanceledInputs */

const tr_geliver_tracking_exception_canceled = /** @type {(inputs: Geliver_Tracking_Exception_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gönderi iptal edildi`)
};

const en_geliver_tracking_exception_canceled = /** @type {(inputs: Geliver_Tracking_Exception_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shipment cancelled`)
};

const de_geliver_tracking_exception_canceled = /** @type {(inputs: Geliver_Tracking_Exception_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sendung storniert`)
};

const ru_geliver_tracking_exception_canceled = /** @type {(inputs: Geliver_Tracking_Exception_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправление отменено`)
};

/**
* | output |
* | --- |
* | "Shipment cancelled" |
*
* @param {Geliver_Tracking_Exception_CanceledInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_tracking_exception_canceled = /** @type {((inputs?: Geliver_Tracking_Exception_CanceledInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Tracking_Exception_CanceledInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_tracking_exception_canceled(inputs)
	if (locale === "de") return de_geliver_tracking_exception_canceled(inputs)
	if (locale === "ru") return ru_geliver_tracking_exception_canceled(inputs)
	return tr_geliver_tracking_exception_canceled(inputs)
});